// extracted by mini-css-extract-plugin
export default {"imgContainer":"Stepper_imgContainer__OZKDU","smallImgContainer":"Stepper_smallImgContainer__8XeDZ","bigContainer":"Stepper_bigContainer__QTJOD"};